/**
 * Stringify group uuids from an array of groups
 * @param {Group[]} selectedGroups
 * @returns {string} comma separated string of group uuids
 */
export function groupsParamValue(selectedGroups) {
  return selectedGroups?.map(({ id }) => id).join(',') ?? '';
}

/**
 * Remove the milliseconds from a date string
 * @param {string} dateString
 * @returns {string}
 */
export function removeMilis(dateString) {
  const dateArr = dateString.split(':');

  return `${dateArr[0]}:${dateArr[1]}:00Z`;
}

/**
 * Generate uri for xm-api get shifts based on shift params
 * eg:
 * uri = "/webapi/xm/1/on-call"
 * paramObj = {groups: 'a,b,c', from: '2020-01-01', to: '2020-01-30'}
 * ->
 * /webapi/xm/1/on-call?groups=a,b,c&from=2020-01-01&to=2020-01-30
 * @param {string} uri
 * @param {object} paramObj
 * @returns {string} encoded uri with params
 */
export function generateGetShiftsURIWithQueryParams(uri, paramObj = {}) {
  const encodedUri = encodeURI(uri);
  const encodeParamValue = param => {
    const paramValue = paramObj[param];
    if (param === 'groups') {
      return paramValue;
    }
    return encodeURIComponent(paramValue);
  };
  const queryParams = Object.keys(paramObj)
    .map(param => `${encodeURIComponent(param)}=${encodeParamValue(param)}`)
    .join('&');

  return queryParams ? `${encodedUri}?${queryParams}` : encodedUri;
}
